export default __webpack_public_path__ + "static/media/KZ.T.03.1477.b4777441.svg";